<template>
    <div>
        <div class="form-group">
            <div class="row">
                <div class="col-md-4">
                    <label>La prestation vendue existe-t-elle déjà ?</label>
                    <select v-model="activity" class="form-control">
                        <option value="" disabled hidden>----- Veuillez sélectionner -----</option>
                        <template v-for="mainActivity in mainActivities">
                          <option v-if="mainActivity.price_type === 'standard'" :key="mainActivity.id"
                                  :value="mainActivity">
                            {{ mainActivity.name }}
                          </option>
                          <optgroup v-else-if="mainActivity.price_type === 'package'" :label="mainActivity.name">
                            <option v-for="packagePrice in mainActivity.package_prices" :key="packagePrice.id"
                                    :value="packagePrice">
                              {{ packagePrice.name }}
                            </option>
                          </optgroup>
                        </template>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-md-6">
                    <label>Prestation vendue *:</label>
                    <input type="text" name="details__input" v-model="newDetail.name" ref="input"
                           placeholder="Exemple" class="form-control" @keydown.enter.prevent="addDetail" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row" style="padding-top: 10px">
                <div class="col-md-2">
                    <label id="date_debut_lb">Date de début <template v-if="datesRequired">*</template>:</label>
                    <datepicker v-model="newDetail.date_debut" name="details__input"
                                :clearButton="!datesRequired" format="yyyy-MM-dd" full-month-name monday-first
                                class="form-control datepicker"
                                @selected="selectedDatebegin" @keydown.enter.prevent="addDetail" />
                </div>

                <div class="col-md-2">
                    <label id="date_fin_lb">Date de fin <template v-if="datesRequired">*</template>:</label>
                    <datepicker v-model="newDetail.date_fin" name="details__input"
                                :disabledDates="dateend.disabledDates" :clearButton="!datesRequired"
                                format="yyyy-MM-dd" full-month-name monday-first
                                class="form-control datepicker"
                                @keydown.enter.prevent="addDetail" />
                </div>

                <input type="hidden" name="detail" :value="this.jsonDetails" id="detail">
            </div>

            <div id="errors_valid" v-show="errors !== false" style="color:red">
              Veuillez remplir tous les champs du détail d'activité (non nuls) et la quantité ne peut pas être négative.
            </div>
        </div>
        <div class="form-group">
            <div class="row" >
                <div class="col-md-1">
                    <label >Quantité *:</label>
                    <input v-model.number="newDetail.quantity" type="number" name="details__input"
                           min="1" class="form-control"
                           @keydown.enter.prevent="addDetail" />
                </div>
                <div class="col-md-2">
                    <label>Prix unitaire {{ taxEnable ? 'TTC' : 'NdT'}} (en €) *:</label>
                    <input v-model="newDetail.price" type="number" name="details__input"
                           placeholder="20" min="0" step="0.01" class="form-control"
                           @blur="formatPrice"
                           @keydow.enter.prevent="addDetail"
                    />
                </div>

                <div v-show="taxEnable" class="col-md-2">
                    <label> Tva (en %, optionnelle) :</label>
                    <input v-model.number="newDetail.tva" type="number" name="tva" class="form-control" />
                </div>

                <div v-if="honoraireEnable" class="col-md-2">
                    <label>Honoraires (en €)</label>
                    <input v-model.number="newDetail.honoraire" type="number" name="honoraire" class="form-control" />
                </div>

              <div class="col-md-2">
                <label>Nombre de participants</label>
                <div class="input-group">
                  <span class="input-group-addon">
                    <input v-model="newDetail.isPackagePrice" type="checkbox" />
                  </span>
                  <input v-model.number="newDetail.nbParticipants" type="number" name="nbParticipants" class="form-control"
                         :disabled="!newDetail.isPackagePrice"
                  />
                </div>
              </div>
            </div>

            <div class="row">
                <div class="col-md-1 text-center" style="padding-top:20px">
                    <a href="javascript:void(0)" class="btn btn-success billingSuccess" id="detail__button" @click.prevent="addDetail">Ajouter</a>
                </div>
            </div>
        </div>

        <table class="table table-striped" v-if="details.length > 0">
            <thead>
                <tr>
                    <th>Dénomination de la prestation</th>
                    <th>Quantité</th>
                    <th>Prix unitaire {{ taxEnable ? 'TTC' : 'NdT' }}</th>
                    <th>Date début</th>
                    <th>Date fin</th>
                    <th v-if="taxEnable">TVA</th>
                    <th v-if="honoraireEnable">Honoraire</th>
                    <th>Total {{ taxEnable ? 'TTC' : 'NdT' }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="detail in details" :key="detail.billingActivityId">
                    <td><strong>{{ detail.name }}</strong></td>
                    <td>{{ detail.quantity }}</td>
                    <td><span class="price">{{ Number.parseFloat(detail.price).toFixed(2) }}</span></td>
                    <td>
                      <span v-if="detail.date_debut" class="time"><span class="icon-calendar"></span> {{ detail.date_debut }}</span>
                    </td>
                    <td>
                      <span v-if="detail.date_fin" class="time"><span class="icon-calendar"></span> {{ detail.date_fin }}</span>
                    </td>
                    <td v-if="taxEnable">
                      <span class="tva">{{ detail.tva ? Number.parseFloat(detail.tva) + '%'  : '' }}</span>
                    </td>
                    <td v-if="honoraireEnable"><span class="price">{{ detail.honoraire }}</span></td>
                    <td><span class="price">{{ Number.parseFloat(detail.price * detail.quantity).toFixed(2) }}</span></td>
                    <td>
                        <a href="javascript:void(0)" class="btn-simple-icon btn-danger pull-right" @click="deleteDetail(detail)">
                          <i class="fa fa-trash"></i>
                        </a>
                        <a href="javascript:void(0)" class="btn-simple-icon pull-right" @click="editDetail(detail)">
                          <i class="fas fa-pencil-alt"></i>
                        </a>
                    </td>
                </tr>
                <tr>
                  <td colspan="6" class="total-price">Total TTC</td>
                  <td colspan="2"><span class="price">{{ priceTotal.toFixed(2) }}</span></td>
                </tr>
            </tbody>
        </table>
        <input type="hidden" :value="priceTotal" name="price" />
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'

    export default {
      name: "billingDetailSoloComponent",
      components: { Datepicker },
      props: {
        olddetails: {},
        officeMainActivities: { required: true },
        officecustomization: { required: true },
        hasbilling: { default: false },
        datesRequired: { default: false }
      },
      data() {
        return {
          mainActivities: [],
          activity: null,
          details: [],
          jsonDetails: '[]',
          newDetail: {
            name: '',
            quantity: 1,
            price: '',
            date_debut: '',
            date_fin: '',
            tauxtva: '',
            isPackagePrice: false,
            nbParticipants: 1
          },
          billingActivityIdIncrement: 0,
          errors: false,
          dateend: {
            disabledDates: { to: new Date(this.beginvalue) }
          },
          editIndex: null,
          taxEnable: this.officecustomization?.taxEnable === true,
          honoraireEnable: this.officecustomization?.honoraire === true
        }
      },
      created() {
        this.resetActivities()
      },
      mounted() {
        if (this.olddetails) {
          this.details = this.olddetails
          if (this.details.length > 0) {
            this.billingActivityIdIncrement = Math.max.apply(Math, this.details.map(d => d.billingActivityId)) +1
            if (this.hasbilling) { // only edit detail if comming from calendar not from edit
              this.editDetail(this.details[0])
            } else {
              this.jsonDetails = JSON.stringify(this.details)
            }
          }
        }
      },
      computed: {
        priceTotal() {
          let total = 0
          let fees = 0

          for (const detail of this.details) {
            total += this.computePriceTotal(detail)
            fees += parseInt(detail.honoraire || 0)
          }

          this.$parent.$emit('update:totalDispatchedPrice', {
            type: 'total',
            quantity: total,
            fees: fees
          })

          return total
        }
      },
      watch: {
        activity(newVal) {
          this.newDetail = { ...this.newDetail, ...newVal };
          if (newVal.fees) this.newDetail.honoraire = newVal.fees
          this.formatPrice()
        },
        jsonDetails() {
          this.$nextTick(function () {
            $('#detail').trigger('change')
          })
        },
        'newDetail.tauxtva': function (newVal) {
          this.newDetail.tva = newVal
        },
        'newDetail.quantity': function (newVal) {
          if (!this.newDetail.isPackagePrice) this.newDetail.nbParticipants = newVal
        },
        'newDetail.isPackagePrice': function (newVal) {
          if (!newVal) this.newDetail.nbParticipants = this.newDetail.quantity
        }
      },
      methods: {
        resetActivities() { // Reset mainactivities
          this.mainActivities = this.deepCopy(this.officeMainActivities)

          this.mainActivities.forEach(act => {
            if (act.price_type === 'package') {
              act.package_prices.forEach(p => {
                p.price = p.price_ttc;
                p.tauxtva = act.tauxtva;
                p.isPackagePrice = true;
              })
            }

            act.isPackagePrice = false;
          })

          this.activity = null;

          for (let key in this.newDetail) {
            this.newDetail[key] = ''
          }

          this.newDetail.quantity = this.newDetail.nbParticipants = 1;
        },
        formatPrice() {
          this.newDetail.price = (Math.round(this.newDetail.price * 100) / 100).toFixed(2)
        },
        addDetail() {
          if (this.newDetail.name && this.newDetail.quantity && this.newDetail.quantity >= 0 && this.newDetail.price
            && (!this.datesRequired || this.newDetail.date_debut && this.newDetail.date_fin))
          {
            let tempDetail = this.deepCopy(this.newDetail)
            if (tempDetail.date_debut) {
              tempDetail.date_debut = new Date(tempDetail.date_debut).toISOString().slice(0, 10)
            }

            if (tempDetail.date_fin) {
              tempDetail.date_fin = new Date(tempDetail.date_fin).toISOString().slice(0, 10)
            }

            if (this.taxEnable && !tempDetail.tva) tempDetail.tva = 0;
            if (this.honoraireEnable && !tempDetail.honoraire) tempDetail.honoraire = 0;

            if (tempDetail.billingActivityId === undefined) // When create new prestation
            {
              tempDetail.billingActivityId = this.billingActivityIdIncrement
              this.billingActivityIdIncrement++
            }

            if (tempDetail.isPackagePrice)
              tempDetail.name += ' - ' + tempDetail.nbParticipants + ' participant' + (tempDetail.nbParticipants > 1 ? 's' : '');

            if (this.editIndex != null) {
              this.details.splice(this.editIndex, 0, tempDetail)
              this.editIndex = null
            } else {
              this.details.push(tempDetail)
            }

            this.$parent.$emit('update-price', this.priceTotal)
            this.resetActivities()
            this.jsonDetails = JSON.stringify(this.details)

            this.errors = false
          } else this.errors = true
        },
        deleteDetail(detail) {
          this.$root.$emit('prestaDelete', detail.billingActivityId)
          this.details.splice(this.details.indexOf(detail), 1)
          this.jsonDetails = JSON.stringify(this.details)
        },
        editDetail(detail) {
          this.newDetail = detail
          if (this.newDetail.isPackagePrice) {
            const name = this.newDetail.name;
            this.newDetail.name = name.substring(0, name.lastIndexOf('-') - 1)
          }

          this.editIndex = this.details.indexOf(detail)
          this.details.splice(this.editIndex, 1)
          this.jsonDetails = JSON.stringify(this.details) // Remove edited detail from json
          this.$refs.input.focus()
        },
        selectedDatebegin(value) {
          this.dateend.disabledDates.to = value
        },
        computePriceTotal(detail) {
            return detail.price * detail.quantity
        },
        deepCopy(src) { // To remove reference
            return JSON.parse(JSON.stringify(src))
        },
      }
    }
</script>

<style>
.total-price {
  text-align: right;
  font-weight: bold;
}
</style>
